import { RouterModule, Routes } from '@angular/router';
import { ReporteInventarioEquiposComponent } from './reporte-inventario-equipos/reporte-inventario-equipos.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  {
    path: 'reporte-inventario-equipos',
    component: ReporteInventarioEquiposComponent,
  },
  {
    path: '',
    redirectTo: 'reporte-inventario-equipos',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportesRoutingModule {}
